/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p.description[_ngcontent-%COMP%]{line-height:11px;margin:2px;padding-right:12px}.thumbnail[_ngcontent-%COMP%]{height:42px;overflow:hidden}.border-promotion[_ngcontent-%COMP%]{padding-top:5px}.product[_ngcontent-%COMP%]   .thumbnail[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{padding:0 3px;width:60%;margin-left:50px;font-size:12px;line-height:20px}#cart-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:3px}"];
export { styles as styles };
